import auth from '@/auth';
import { FETCH_CAPTCHA, SMS_CODE_COUNTER_RESET, SMS_CODE_COUNTER_TICK, LOGIN, LOGOUT } from './types';

export default {
    [FETCH_CAPTCHA](state, payload) {
        state.captchaImg = `data:image/png;base64,${payload.captcha}`;
        state.captchaTag = payload.tag;
    },
    [SMS_CODE_COUNTER_RESET](state) {
        state.countdown = 60;
    },
    [SMS_CODE_COUNTER_TICK](state) {
        if (state.countdown > 0) {
            state.countdown -= 1;
        }
    },
    [LOGIN](state, payload) {
        state.brand_new = payload.brand_new;
        auth.login(payload.token);
    },
    [LOGOUT]() {
        auth.logoff();
    },
};



// WEBPACK FOOTER //
// ./src/store/auth/mutations.js